import { render, staticRenderFns } from "./class-quesbank.vue?vue&type=template&id=16f80a92&scoped=true"
import script from "./class-quesbank.vue?vue&type=script&lang=js"
export * from "./class-quesbank.vue?vue&type=script&lang=js"
import style0 from "./class-quesbank.vue?vue&type=style&index=0&id=16f80a92&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f80a92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16f80a92')) {
      api.createRecord('16f80a92', component.options)
    } else {
      api.reload('16f80a92', component.options)
    }
    module.hot.accept("./class-quesbank.vue?vue&type=template&id=16f80a92&scoped=true", function () {
      api.rerender('16f80a92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/senate/class-quesbank.vue"
export default component.exports